import { useEffect, useCallback, useRef } from 'react';
import WebApp from '@twa-dev/sdk';

export function useMainButton({ text, onClick, visible = true, disabled = false, showProgress = false }) {
    const callbackRef = useRef(onClick);
    callbackRef.current = onClick;

    const stableHandler = useCallback(() => {
        callbackRef.current?.();
    }, []);

    useEffect(() => {
        const btn = WebApp.MainButton;

        if (!visible) {
            btn.hide();
            return () => { btn.offClick(stableHandler); };
        }

        btn.setText(text);
        btn.onClick(stableHandler);

        if (disabled) {
            btn.disable();
        } else {
            btn.enable();
        }

        if (showProgress) {
            btn.showProgress(false);
        } else {
            btn.hideProgress();
        }

        btn.show();

        return () => {
            btn.offClick(stableHandler);
            btn.hideProgress();
            btn.hide();
        };
    }, [text, visible, disabled, showProgress, stableHandler]);
}
